import React, { useContext, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { contact_us } from "../../component/services/ApiCalls";
import { AppStoreContext } from "../../store/AppStore";
import consoleService from "../../utility/services/consoleService";
import "../sass/MottruckLanding.scss";
import "./ContactDemo.scss";

const Contacts = () => {
  const defaultValues = {
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  };
  const { setIsLoading } = useContext(AppStoreContext);
  const infoForm = useForm({ defaultValues });
  const { control, handleSubmit, setError, reset, formState } = infoForm;
  const { errors } = formState;

  const onSubmit = async (data) => {
    if (Object.values(data).every((field) => field.toString().trim().length > 0)) {
      try {
        contact_us({ ...data, subject: "contact message" })
          .then((res) => {
            if (res.status == 1) {
              toast("Thanks, We will be get in touch with you asap");
              reset();
            } else {
              throw new Error(`API request failed with status ${res.status}`);
            }
          })
          .catch((err) => {
            console.log("err", err);
            toast("Something went wrong. Please try again.");
          });
      } catch (err) {
        consoleService("error in onSubmitInfoForm function:", err);
      }
    } else {
      for (const key in data) {
        if (data[key].length === 0) {
          setError(key, { type: "manual", message: `${key} is required` });
        }
      }
    }
  };

  useEffect(() => {
    setIsLoading(false);
  }, [setIsLoading]);

  return (
    <div className="mtk-landing mtk-split-page mtk-contact-page">
      <section className="mtk-split-section">
        <div className="mtk-split-grid">
          <div className="mtk-split-left mtk-contact-left">
            <div className="mtk-contact-stack">
              <h1
                className="mtk-contact-title"
                aria-label="Let's get your freight moving."
              >
                {["Let's get your", "freight moving."].map((line) => (
                  <span className="mtk-track-line" aria-hidden="true" key={line}>
                    {line.split("").map((ch, i) => (
                      <span key={`${line}-${i}`}>{ch === " " ? "\u00A0" : ch}</span>
                    ))}
                  </span>
                ))}
              </h1>
            </div>
          </div>

          <div className="mtk-split-right">
            <form className="mtk-split-form" onSubmit={handleSubmit(onSubmit)}>
              <div className="field">
                <label>Name</label>
                <Controller
                  name="name"
                  control={control}
                  render={({ field }) => (
                    <input type="text" placeholder="John Carter" {...field} />
                  )}
                />
                {errors.name && <small className="err">{errors.name.message}</small>}
              </div>
              <div className="field">
                <label>Email</label>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <input type="email" placeholder="example@email.com" {...field} />
                  )}
                />
              </div>
              <div className="field-row">
                <div className="field">
                  <label>Phone</label>
                  <Controller
                    name="phone"
                    control={control}
                    render={({ field }) => (
                      <input type="text" placeholder="+33 6 00 00 00" {...field} />
                    )}
                  />
                </div>
                <div className="field">
                  <label>Company</label>
                  <Controller
                    name="company"
                    control={control}
                    render={({ field }) => (
                      <input type="text" placeholder="Your company" {...field} />
                    )}
                  />
                </div>
              </div>
              <div className="field field-message">
                <label>Message</label>
                <Controller
                  name="message"
                  control={control}
                  render={({ field }) => (
                    <textarea placeholder="Let us know how we can help." rows={4} {...field} />
                  )}
                />
              </div>
              <button type="submit" className="mtk-split-submit">
                Send message
              </button>
            </form>
          </div>
        </div>
      </section>
      <ToastContainer />
    </div>
  );
};

export default Contacts;
